/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import AuthService from "./AuthService";

class BoletoService {
    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL || "https://portalrelacionamentoapi.dev-gam.com";
    }

    async getTitulosVencidos(cdCliente) {
        try {
            if (!AuthService.getToken()) {
                await AuthService.login();
            }

            const response = await axios.get(
                `${this.apiUrl}/notificacao/selecionar/${cdCliente}/TITULOS_VENCIDOS`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`, // Token de autentica��o
                    },
                }
            );
            const conteudo = response.data.conteudo;
            const totalVencido = conteudo.reduce(
                (acc, item) => acc + item.vlSaldo,
                0
            );

            return {
                totalVencido,
            };
        } catch (error) {
            console.error("Erro ao buscar t�tulos vencidos:", error);
            throw new Error("Erro ao buscar t�tulos vencidos.");
        }
    }
    async getTitulosVencer(cdCliente) {
        try {
            if (!AuthService.getToken()) {
                await AuthService.login();
            }

            const response = await axios.get(
                `${this.apiUrl}/notificacao/selecionar/${cdCliente}/TITULOS_VENCER_D1`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`, // Token de autentica��o
                    },
                }
            );
            const conteudo = response.data.conteudo;
            const totalVencer = conteudo.reduce(
                (acc, item) => acc + item.vlSaldo,
                0
            );

            return {
                totalVencer,
            };
        } catch (error) {
            console.error("Erro ao buscar t�tulos vencidos:", error);
            throw new Error("Erro ao buscar t�tulos vencidos.");
        }
    }

    async getListaBoletos(cdCliente, filtros) {
        try {
            // Autentica��o
            if (!AuthService.getToken()) {
                await AuthService.login();
            }

            const response = await axios.post(
                `${this.apiUrl}/boleto/listar/${cdCliente}`,
                filtros, // Envia o objeto `filtros` no corpo da requisi��o
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`,
                    },
                }
            );

            const conteudo = response.data.conteudo;
            return conteudo; // Acessa diretamente o conte�do da resposta
        } catch (error) {
            console.error("Erro ao buscar lista de boletos:", error);
            throw new Error("Erro ao buscar lista de boletos.");
        }
    }

    async getVisualizarBoleto(boleto, empresa) {
        try {
            // Autentica��o
            if (!AuthService.getToken()) {
                console.log("Token não encontrado. Realizando login...");
                await AuthService.login();
            }

            console.log(`Buscando boleto: ${boleto}, Empresa: ${empresa}`);
            const response = await axios.get(
                `${this.apiUrl}/boleto/exibir/${boleto}/${empresa}`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`,
                    },
                    responseType: "blob", // Configura para receber um Blob
                }
            );

            //console.log("Resposta do servidor recebida:", response);
            // Retorna o Blob diretamente
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar visualização de boletos:", error);
            throw new Error("Erro ao buscar visualização de boletos.");
        }
    }

    async agruparBoletos(cdCliente, digitoCliente, agrupar) {
        try {
            console.log("🔧 BoletoService: Iniciando agrupamento de boletos");
            console.log("🔧 BoletoService: Parâmetros recebidos:", { 
                cdCliente, 
                digitoCliente, 
                agrupar,
                tipoCdCliente: typeof cdCliente,
                tipoDigitoCliente: typeof digitoCliente,
                tipoAgrupar: typeof agrupar
            });
            
            if (!AuthService.getToken()) {
                console.log("🔧 BoletoService: Token não encontrado, realizando login...");
                await AuthService.login();
            }

            const codigoCompleto = `${cdCliente}${digitoCliente}`;
            console.log("🔧 BoletoService: Código completo construído:", codigoCompleto);
            
            const url = `${this.apiUrl}/cliente/agrupar-boletos/${codigoCompleto}/${agrupar}`;
            console.log("🔧 BoletoService: URL da requisição:", url);
            console.log("🔧 BoletoService: URL decodificada:", decodeURIComponent(url));
            console.log("🔧 BoletoService: Valor 'agrupar' na URL:", agrupar, "Tipo:", typeof agrupar);
            
            console.log("🔧 BoletoService: Token de autorização:", AuthService.getToken() ? "Presente" : "Ausente");
            
            const response = await axios.post(
                url,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("🔧 BoletoService: Resposta da API:", response.data);
            console.log("🔧 BoletoService: Status da resposta:", response.status);
            
            return response.data;
        } catch (error) {
            console.error("🔧 BoletoService: Erro detalhado ao atualizar configuração de agrupamento de boletos:");
            console.error("🔧 BoletoService: Mensagem de erro:", error.message);
            console.error("🔧 BoletoService: Status do erro:", error.response?.status);
            console.error("🔧 BoletoService: Dados do erro:", error.response?.data);
            console.error("🔧 BoletoService: Headers do erro:", error.response?.headers);
            console.error("🔧 BoletoService: Configuração da requisição:", {
                url: error.config?.url,
                method: error.config?.method,
                headers: error.config?.headers,
                data: error.config?.data,
                params: error.config?.params
            });
            throw new Error("Erro ao atualizar configuração de agrupamento de boletos.");
        }
    }

    async configurarBoletoDigital(cdCliente, digitoCliente, ativo) {
        try {
            console.log("🔧 BoletoService: Iniciando configuração de boleto digital");
            console.log("🔧 BoletoService: Parâmetros recebidos:", { 
                cdCliente, 
                digitoCliente, 
                ativo,
                tipoCdCliente: typeof cdCliente,
                tipoDigitoCliente: typeof digitoCliente,
                tipoAtivo: typeof ativo
            });
            
            if (!AuthService.getToken()) {
                console.log("🔧 BoletoService: Token não encontrado, realizando login...");
                await AuthService.login();
            }

            const codigoCompleto = `${cdCliente}${digitoCliente}`;
            console.log("🔧 BoletoService: Código completo construído:", codigoCompleto);
            
            const url = `${this.apiUrl}/cliente/boleto-digital/${codigoCompleto}/${ativo}`;
            console.log("🔧 BoletoService: URL da requisição:", url);
            console.log("🔧 BoletoService: URL decodificada:", decodeURIComponent(url));
            console.log("🔧 BoletoService: Valor 'ativo' na URL:", ativo, "Tipo:", typeof ativo);
            
            console.log("🔧 BoletoService: Token de autorização:", AuthService.getToken() ? "Presente" : "Ausente");
            
            const response = await axios.post(
                url,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("🔧 BoletoService: Resposta da API:", response.data);
            console.log("🔧 BoletoService: Status da resposta:", response.status);
            
            return response.data;
        } catch (error) {
            console.error("🔧 BoletoService: Erro detalhado ao atualizar configuração de boleto digital:");
            console.error("🔧 BoletoService: Mensagem de erro:", error.message);
            console.error("🔧 BoletoService: Status do erro:", error.response?.status);
            console.error("🔧 BoletoService: Dados do erro:", error.response?.data);
            console.error("🔧 BoletoService: Headers do erro:", error.response?.headers);
            console.error("🔧 BoletoService: Configuração da requisição:", {
                url: error.config?.url,
                method: error.config?.method,
                headers: error.config?.headers,
                data: error.config?.data,
                params: error.config?.params
            });
            throw new Error("Erro ao atualizar configuração de boleto digital.");
        }
    }
}

export default new BoletoService();
